import { put, takeEvery, call, select } from "redux-saga/effects";
import { PostConstants } from "../constants/post.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    submitPostFailure,
    submitPostSuccess,
    deletePostSuccess,
    deletePostFailure,
    reportPostSuccess,
    reportPostFailure
} from "../actions/post.actions";
import { jsToPostRecord } from "../records/post.record";
import { postContents, userContents } from "./query.helper";
import { push } from "react-router-redux";

export function* submitPost() {
    yield takeEvery(PostConstants.SUBMIT_POST, doSubmitPost);
}

export function* deletePost() {
    yield takeEvery(PostConstants.DELETE_POST, doDeletePost);
}

export function* reportPost() {
    yield takeEvery(PostConstants.REPORT_POST, doReportPost);
}

function* doSubmitPost({ payload: { post } }) {
    try {
        let newPost;
        if (!post.id) {
            const query = `mutation {
                createPost(
                    body: ${JSON.stringify(post.body.trim())}
                    language: ${JSON.stringify(post.language)}
                ) {
                    id
                    creationDate
                    lastUpdateDate
                    body
                    language
                    authorId
                    author ${userContents}
                }
            }`;

            let { createPost } = yield call(doGraphQLQuery, query);
            newPost = createPost;
        } else {
            const query = `mutation {
                updatePost(
                    id: ${JSON.stringify(post.id)}
                    body: ${JSON.stringify(post.body.trim())}
                    language: ${JSON.stringify(post.language)}
                ) ${postContents}
            }`;

            let { updatePost } = yield call(doGraphQLQuery, query);
            newPost = updatePost;
        }

        yield put(submitPostSuccess({ post: jsToPostRecord(newPost) }));
    } catch (e) {
        yield call(handleFailure, e, submitPostFailure);
    }
}

function* doDeletePost({ payload: { post } }) {
    try {
        const query = `mutation {
            deletePost(
                id: ${JSON.stringify(post.id)}
            )
        }`;
        yield call(doGraphQLQuery, query);
        yield put(deletePostSuccess({ post }));
        yield call(redirectIfViewPostPage, post);
    } catch (e) {
        yield call(handleFailure, e, deletePostFailure);
    }
}

function* redirectIfViewPostPage(post) {
    const pathname = yield select(({ router: { location: { pathname } } }) => {
        return pathname;
    });
    if (pathname === "/posts/" + post.id) {
        yield put(push("/feed"));
    }
}

function* doReportPost({ payload: { post } }) {
    try {
        const query = `mutation {
            reportPost(
                id: ${JSON.stringify(post.id)}
            )
        }`;
        yield call(doGraphQLQuery, query);
        yield put(reportPostSuccess({ post }));
    } catch (e) {
        yield call(handleFailure, e, reportPostFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/post.saga.js